module.exports = __webpack_public_path__ + "static/media/DSC_0049.1851f08f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0049.jpg
// module id = 682
// module chunks = 0